import React from "react";
import { FaPiggyBank, FaWallet } from "react-icons/fa";
import {
  MdDashboard,
  MdPeople,
  MdSettings,
  MdBarChart,
  MdPerson,
  MdShoppingCart,
  MdGroup,
  MdWork,
  MdAnalytics,
  MdKeyboardArrowDown,
  MdSecurity,
  MdEmail,
  MdNotifications,
  MdDocumentScanner,
  MdMoney,
  MdSubscriptions,
  MdBusiness,
  MdCampaign,
  MdBrandingWatermark,
  MdContactSupport,
  MdVerifiedUser,
  MdRequestQuote,
} from "react-icons/md";

export type NavItem = {
  title: string;
  path: string;
  icon: React.ComponentType<{ className?: string; size?: number }>;
  children?: NavItem[];
};

export const navigationConfig: Record<string, NavItem[]> = {
  admin: [
    { title: "Dashboard", path: "/dashboard", icon: MdDashboard },
    {
      title: "User Management",
      path: "/dashboard/users",
      icon: MdPeople,
      children: [
        { title: "All Users", path: "/dashboard/users/all", icon: MdGroup },
        { title: "Influencers", path: "/dashboard/users/influencers", icon: MdPerson },
        { title: "Organizations", path: "/dashboard/org/all", icon: MdBusiness },
      ],
    },
    {
      title: "Verifications",
      path: "/dashboard/organization",
      icon: MdBusiness,
      children: [
        { title: "Organizations", path: "/dashboard/verification/requests", icon: MdVerifiedUser },
        { title: "Influencers", path: "/dashboard/influencer/requests", icon: MdVerifiedUser },
      ]
    },
    { title: "Campaigns", path: "/dashboard/campaings", icon: MdCampaign },
    { title: "Brands", path: "/dashboard/brands", icon: MdBrandingWatermark },
    { title: "Subscriptions", path: "/dashboard/subscriptions", icon: MdSubscriptions },
    { title: "Coupons", path: "/dashboard/coupons", icon: MdMoney },
    { title: "Wallet Transactions", path: "/dashboard/wallets", icon: FaWallet },
    { title: "Withdrawl Requests", path: "/dashboard/withdrawl-request", icon: MdRequestQuote },
    { title: "Payments", path: "/dashboard/payments", icon: MdMoney },
    { title: "Bank Details", path: "/dashboard/bankdetails", icon: FaPiggyBank },
    { title: "Subscription Info", path: "/dashboard/subscriptioninfo", icon: MdSubscriptions },
    { title: "Queries", path: "/dashboard/query", icon: MdContactSupport },
    {
      title: "Contacts",
      path: "/dashboard/contacts",
      icon: MdEmail,
      children: [
        {
          title: "users",
          path: "/dashboard/contacts/users",
          icon: MdGroup,
        },
      ],
    },
    // {
    //   title: "Settings",
    //   path: "/dashboard/settings",
    //   icon: MdSettings,
    //   children: [
    //     { title: "Change Theme", path: "/dashboard/settings/theme", icon: MdSettings },
    //   ],
    // },
  ],
  organization: [
    { title: "Dashboard", path: "/dashboard", icon: MdDashboard },
    { title: "Profile", path: "/dashboard/profile", icon: MdPerson },
    { title: "Documents", path: "/dashboard/documents", icon: MdDocumentScanner },
    { title: "Brands", path: "/dashboard/brands", icon: MdBrandingWatermark },
    { title: "Campaigns", path: "/dashboard/campaings", icon: MdCampaign },
    { title: "Stats", path: "/dashboard/stats", icon: MdAnalytics },
    { title: "Subscriptions", path: "/dashboard/subscriptions", icon: MdSubscriptions },
    { title: "Payments", path: "/dashboard/payments", icon: MdMoney },
    { title: "My Queries", path: "/dashboard/myquery", icon: MdContactSupport },
    { title: "Queries", path: "/dashboard/query", icon: MdContactSupport },
    {
      title: "Settings",
      path: "/dashboard/settings",
      icon: MdSettings,
      children: [
        { title: "Change Theme", path: "/dashboard/settings/theme", icon: MdSettings },
      ],
    },
  ],
  user: [
    { title: "Dashboard", path: "/dashboard", icon: MdDashboard },
    { title: "Profile", path: "/dashboard/profile", icon: MdPerson },
    { title: "Campaigns", path: "/dashboard/campaings", icon: MdCampaign },
    { title: "My Campaign Requests", path: "/dashboard/campaings/request", icon: MdWork },
    { title: "My Queries", path: "/dashboard/myquery", icon: MdContactSupport },
    { title: "Queries", path: "/dashboard/query", icon: MdContactSupport },
    { title: "Subscriptions", path: "/dashboard/subscriptions", icon: MdSubscriptions },
    { title: "Social Accounts", path: "/dashboard/social/accounts", icon: MdSecurity },
    {
      title: "Settings",
      path: "/dashboard/settings",
      icon: MdSettings,
      children: [
        { title: "Change Theme", path: "/dashboard/settings/theme", icon: MdSettings },
      ],
    },
  ],
};